module.exports = __webpack_public_path__ + "img/green_029.3b292ced.png";